import { Box, Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';

import FourIcon from '../../assets/icons/icon-features-4k.svg';
import MovieIcon from '../../assets/icons/icon-features-movie.svg';
import SupportIcon from '../../assets/icons/icon-features-support.svg';

const Feature = ({ icon, title, description, theme }) => {
  return (
    <Stack
      gap={2}
      sx={{
        justifyContent: 'flex-start',
        p: 3,
        border: '1px solid',
        borderColor: 'primary.neutral100',
        borderRadius: theme.shape.roundedButtonBorderRadius,
        boxShadow: `0 0 0 0.5px ${theme.palette.primary.neutral100}`,
        width: { xs: '100%', sm: 'calc(100% / 2)', md: 'calc(100% / 3)' },
      }}
    >
      <Box sx={{ pb: 1, minHeight: '45px' }}>{icon}</Box>
      <Typography variant="h3" sx={{ fontSize: '28px', fontWeight: '600' }}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: 'text.secondary', fontSize: '16px' }}
      >
        {description}
      </Typography>
    </Stack>
  );
};

export default function Section4() {
  const { t } = useTranslation();
  const theme = useTheme();

  const features = [
    {
      icon: <img src={FourIcon} alt="4K icon" loading="lazy" />,
      title: t('HOME_PAGE.SECTION4.FEATURES.0.TITLE'),
      description: t('HOME_PAGE.SECTION4.FEATURES.0.DESCRIPTION'),
    },
    {
      icon: <img src={MovieIcon} alt="Movie icon" loading="lazy" />,
      title: t('HOME_PAGE.SECTION4.FEATURES.1.TITLE'),
      description: t('HOME_PAGE.SECTION4.FEATURES.1.DESCRIPTION'),
    },
    {
      icon: <img src={SupportIcon} alt="Support icon" loading="lazy" />,
      title: t('HOME_PAGE.SECTION4.FEATURES.2.TITLE'),
      description: t('HOME_PAGE.SECTION4.FEATURES.2.DESCRIPTION'),
    },
  ];
  return (
    <Container
      component="section"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column' },
        justifyContent: 'center',
        alignItems: 'center',
        py: { xs: 8, md: 10 },
      }}
      maxWidth="lg"
    >
      <Stack gap={2}>
        <Stack component={'header'} gap={2}>
          <Typography
            variant="h2"
            sx={{ fontSize: '32px', fontWeight: '600', textAlign: 'center' }}
          >
            {t('HOME_PAGE.SECTION4.TITLE')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              fontSize: '16px',
              fontWeight: '300',
              textAlign: 'center',
            }}
          >
            {t('HOME_PAGE.SECTION4.PARAGRAPH')}
          </Typography>
        </Stack>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          gap={2}
          sx={{
            mt: '32px',
          }}
        >
          {features.map((feature, i) => (
            <Feature
              key={i}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              theme={theme}
            />
          ))}
        </Stack>
      </Stack>
    </Container>
  );
}
